export default (block_id = false) => ({
	block_id: block_id,
	inputElements: [],
	init() {
		const inputs = [
			...this.$root.querySelectorAll("input, select, texarea"),
		].filter((v) => {
			if (v.name === "" || v.dataset.validationRules === undefined)
				return false;
			return true;
		});

		this.inputElements = [...inputs].map((v) => {
			v.required = false;
			this[v.name.replace(/(\[\])/, "")] = {
				errorMessage: false,
			};
			return {
				element: v,
				name: v.name,
				type: v.type,
				rules: v.dataset.validationRules,
			};
		});
	},
	submit(e) {
		let valid = true;
		this.inputElements.filter((ele) => {
			const rules = JSON.parse(ele.rules);
			this[ele.name.replace(/(\[\])/, "")].errorMessage = false;
			rules.forEach((rule) => {
				if (
					!this.validationRules[rule.name](this, ele, rule.condition)
				) {
					this[ele.name.replace(/(\[\])/, "")].errorMessage = true;
					valid = false;
				}
			});
		});
		if (!valid) {
			e.preventDefault();
		} else {
			if (this.block_id) {
				this.renameInputs(false);
				setTimeout(() => {
					this.renameInputs(true);
				}, 200);
			}
		}
	},
	validationRules: {
		required: (alpine, input) => {
			if (input.element.type == "checkbox") {
				return input.element.checked;
			} else {
				return input.element.value !== "";
			}
		},
		groupRequired: (alpine, input) => {
			const group = alpine.$root.querySelector(
				'*[name="' + input.element.name + '"]:checked'
			);
			return group;
		},
		groupRequiredOr: (alpine, input, condition) => {
			const group = alpine.$root.querySelector(
				'*[name="' + input.element.name + '"]:checked'
			);
			const or = alpine.$root.querySelector(
				'*[name="' + condition + '"]'
			).value;
			return group || or;
		},
		sameAs: (alpine, input, condition) => {
			const firstInput = alpine.$root.querySelector(
				'*[name="' + input.element.name + '"]'
			).value;
			const secondInput = alpine.$root.querySelector(
				'*[name="' + condition + '"]'
			).value;

			return firstInput == secondInput;
		},
	},
	renameInputs(revert) {
		[...this.$root.querySelectorAll("input, select, texarea")].forEach(
			(v, i, a) => {
				let inputName = v.getAttribute("name");
				if (inputName) {
					if (revert) {
						if (!inputName.includes(this.block_id)) {
							v.setAttribute(
								"name",
								inputName.replace(
									inputName,
									inputName + "_" + this.block_id
								)
							);
						}
					} else {
						v.setAttribute(
							"name",
							inputName.replace("_" + this.block_id, "")
						);
					}
				}
			}
		);
	},
});
